"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Container;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Container = _interopRequireDefault(require("@material-ui/core/Container"));
var _styles = require("@material-ui/core/styles");
const useStyles = (0, _styles.makeStyles)(theme => ({
  fixed: {
    [theme.breakpoints.down("xs")]: {
      maxWidth: 425
    }
  }
}));
function Container(props) {
  const classes = useStyles(props);
  return /*#__PURE__*/_react.default.createElement(_Container.default, (0, _extends2.default)({
    fixed: true
  }, props, {
    classes: classes
  }));
}